export default __webpack_public_path__ + "static/media/bergen_4.1cc0b1c0.jpg";